import handshake from "../images/graphics/handshake.svg";
import clock from "../images/graphics/clock.svg";
import speech from "../images/graphics/speech.svg";

const rationaleData = [
  {
    header: "Professional yet personal",
    headerSp: "Profesionalas y amigables",
    content:
      "As a smaller business, we take time ensuring that your needs are met. Our clients are like family to us.",
    contentSp:
      "Como una empresa pequeña, nos tomamos el tiempo para asegurarnos de satisfacer tus necesidades. Nuestros clientes son como una familia para nosotros.",
    img: handshake,
  },
  {
    header: "Same day services",
    headerSp: "Servicios el mismo dia",
    content:
      "In most cases, we offer same day services. Please contact us for availability.",
    contentSp:
      "En la mayoría de los casos, ofrecemos servicios el mismo día. Pónte en contacto con nosotros para conocer nuestra disponibilidad.",
    img: clock,
  },
  {
    header: "Bilingual",
    headerSp: "Bilingüe",
    content:
      "English and Spanish. We focus on clear communication, whether in English or in Spanish.",
    contentSp:
      "Inglés y español. Nos enfocamos en una comunicación clara, ya sea en inglés o en español.",
    img: speech,
  },
];

export default rationaleData;
